import React from 'react';
import { connect } from 'react-redux';
import { fetchAllClusterList, selectCuster } from '@/slices/kopClusterSlice';
import CulsterAddon, { getCurrentCluster } from '../CulsterAddon';

function KOPClusterAddon({
  allList,
  currentCluster,
  fetchAllClusterList,
  selectCuster,
  clusterType,
  collapsed,
}) {
  return (
    <CulsterAddon
      allList={allList}
      currentCluster={currentCluster}
      fetchAllClusterList={fetchAllClusterList}
      selectCuster={selectCuster}
      clusterType={clusterType}
      collapsed={collapsed}
    />
  );
}

export default connect(
  (state) => ({
    allList: state.kopCluster.allList,
    currentCluster: getCurrentCluster(state.kopCluster.allList),
  }),
  {
    fetchAllClusterList,
    selectCuster,
  },
)(KOPClusterAddon);
